import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { BadgeCheck, Sparkles, Landmark, Map } from "lucide-react";
import { fadeUp, stagger } from "@/lib/motion";

const CARDS = [
  { icon: BadgeCheck, title: "Verified Listings", desc: "Every property checked by our team.", tint: "bg-[#10B981]/12 text-[#0E9F6E]" },
  { icon: Sparkles, title: "AI Search", desc: "Describe your dream home in plain words.", tint: "bg-[#1E3A8A]/10 text-[#1E3A8A] dark:text-[#7AA0FF]" },
  { icon: Landmark, title: "Mortgage Support", desc: "Estimate payments with partner banks.", tint: "bg-[#F59E0B]/12 text-[#D97706]" },
  { icon: Map, title: "Interactive Maps", desc: "Explore prices and areas on a live map.", tint: "bg-[#7C3AED]/10 text-[#7C3AED] dark:text-[#A78BFA]" },
];

export const WhyAbay = () => {
  const navigate = useNavigate();
  return (
    <section className="bg-background py-12 sm:py-16" data-testid="why-section">
      <div className="abay-container">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="text-2xl font-bold tracking-tight text-foreground sm:text-3xl">Why ABAY360</h2>
            <p className="mt-2 text-sm text-muted-foreground sm:text-base">Ethiopia&apos;s most trusted, AI-first property platform.</p>
          </div>
          <button
            type="button"
            data-testid="why-cta-search"
            onClick={() => navigate("/map-search")}
            className="hidden shrink-0 items-center gap-1 text-sm font-semibold text-[#1E3A8A] hover:underline dark:text-[#7AA0FF] sm:flex"
          >
            Start searching
          </button>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="mt-6 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4"
        >
          {CARDS.map((c) => (
            <motion.div
              key={c.title}
              variants={fadeUp}
              data-testid={`why-card-${c.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="rounded-2xl border border-border bg-card p-6 shadow-[var(--shadow-sm)] transition-shadow duration-200 hover:shadow-[var(--shadow-md)]"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-2xl ${c.tint}`}>
                <c.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground">{c.title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{c.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
